import StoreProc from './StoreProc'

const StorePlugin = {}

StorePlugin.install = function (Vue) {
  Vue.prototype.$_sp = StoreProc
}

export default StorePlugin
